/** A single description for permissions on the snapshot level. */

/**
 * Object that determines all different permission rules for users to get
 * access on the snapshot level.
 */

/** Names for all permissions within the snapshot level. */
export let RequiredPermissionSnapshotLevelName = /*#__PURE__*/function (RequiredPermissionSnapshotLevelName) {
  /** Whether the user can manage the snapshot (rename, delete, change access level) */
  RequiredPermissionSnapshotLevelName["canManageSnapshot"] = "canManageSnapshot";
  /** Whether the user can view all members with access to the snapshot */
  RequiredPermissionSnapshotLevelName["canViewAllSnapshotMembers"] = "canViewAllSnapshotMembers";
  return RequiredPermissionSnapshotLevelName;
}({});